module.exports = __webpack_public_path__ + "img/group2582.ca9cb192.svg";